import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ScontiService {

  /*
  static getScontiByIdUtente = (id_utente) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdUtente`;
      ApiService.postRequest(resolve, reject, url, { id_utente });
    });
  };

  static createSconto = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };
  */

 // --- METODO MODIFICATO ---
  // Ora cerca gli sconti per id_agenzia invece che id_utente
  static getScontiByIdAgenzia = (id_agenzia) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdAgenzia`; // Assumiamo che esista un nuovo endpoint
      ApiService.postRequest(resolve, reject, url, { id_agenzia });
    });
  };

  static getScontiByIdSuperpartner = (id_superpartner) => {
    return new Promise((resolve, reject) => {
        // Chiama il nuovo endpoint del backend
        const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdSuperpartner`;
        ApiService.postRequest(resolve, reject, url, { id_superpartner });
    });
  };

  // --- METODO MODIFICATO ---
  // Ora invia id_agenzia e id_superpartner
  static createSconto = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };
  
  static deleteSconto = (id_sconto) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/delete`;
      ApiService.delete(resolve, reject, url, { id_sconto });
    });
  };

  static getScontoByIdCorso = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti/findByIdCorso`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static getScontiSuperPartner = (params) => {
    // Chiama un nuovo endpoint GET che accetta id_partner come parametro
    const url = `${REACT_APP_REST_ENDPOINT}/sconti-superpartner/findByPartner?id_partner=${params.id_partner}`;
    return new Promise((resolve, reject) => ApiService.getRequest(resolve, reject, url));
  };

  static createScontoSuperPartner = (data) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti-superpartner/create`;
      return new Promise((resolve, reject) => ApiService.postRequest(resolve, reject, url, data));
  };

  static deleteScontoSuperPartner = (data) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sconti-superpartner/delete`;
      return new Promise((resolve, reject) => ApiService.delete(resolve, reject, url, data));
  };

}
